import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import React from "react";
import { tableData, tableData2 } from "../../data";
const StaticTable = ({ hide, visible }) => {
  const columns = [
    {
      title: "McKesson",
      dataIndex: "label",
      key: "label",
      width: "60%",
      align: "center",
    },
    { title: "Admin Fee Percent", dataIndex: "fee", key: "fee", width: "40%" },
  ];
  const columns2 = [
    {
      title: "IPC",
      dataIndex: "label",
      key: "label",
      width: "60%",
      align: "center",
    },
    { title: "Admin Fee Percent", dataIndex: "fee", key: "fee", width: "40%" },
  ];
  return (
    <Modal
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <span className="text-[#000833] text-[15px] mr-[12%] md:mr-[40%]">
              Legal Disclosure Statement
            </span>
            <Button
              type="text"
              icon={<CloseOutlined className="text-[20px]" />}
              onClick={hide}
              style={
                {
                  //   marginRight: -12,
                }
              }
            />
          </div>
          <div
            style={{
              // borderBottom: "1px solid #f0f0f0",
              // marginLeft: -24,
              // marginRight: -24,
              // marginTop: -16,
              fontSize: "16px",
              fontWeight: 500,
              color: "#262626",
              display: "flex",
              // alignItems: "center",
              marginTop: 20,
              justifyContent: "space-between",
              // background:"#e8e6e6",
            }}
          >
            <div
              className="bg-[#e8e6e6] mx-4"
              style={{ padding: "16px 24px", borderRadius: 6, width: "100%" }}
            >
              <span style={{}} className="text-[14px]">
                As outlined in your Membership Agreement, IPC operates as a
                pharmacy GPO that collects administrative fees based on your
                purchases. The structure below outlines how IPC is compensated
                by our contracted vendors, McKesson and IPC, respectively, based
                on your pharmacy’s total purchase volume. If you have any
                questions regarding the administrative fees collected, please
                contact our team at customerservice@aaparx.com
              </span>
            </div>
            {/* <Button
            type="text"
            icon={<CloseOutlined className="text-[20px]"/>}
            onClick={hide}
            style={{
            //   marginRight: -12,
            }}
          /> */}
          </div>
        </>
      }
      open={visible}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="profile-modal"
      closeIcon={null}
      footer={null}
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <Table
        columns={columns}
        dataSource={tableData}
        size="middle"
        rowKey="id"
        className="custom-table user-tbl filter-table"
        scroll={{ x: "max-content" }}
        pagination={false}
      />
      <div className="px-5" style={{ marginTop: -6 }}>
        <span className="text-[#000833] text-[15px]">
          *IPC does NOT make any admin on MHA accounts.
        </span>
      </div>

      <Table
        columns={columns2}
        dataSource={tableData2}
        size="middle"
        className="custom-table user-tbl filter-table"
        scroll={{ x: "max-content" }}
        rowKey="id"
        pagination={false}
      />
      <div className="px-5 flex flex-col" style={{ marginTop: -6 }}>
        <span className="text-[#000833] text-[15px]">
          *IPC does NOT make any admin on MHA accounts.
        </span>
        <span className="text-[#000833] text-[15px]">
          **IPC does NOT make any admin on Brand Purchases.
        </span>
      </div>
    </Modal>
  );
};

export default StaticTable;
